import $ from 'jquery';

function tabs() {
	//Flexible Tabs

	//opening the first tab by default
	$('.tab-container .tab-header').each(function (i, tabs) {
		if (i === 0) {
			$(this).addClass('open');
			$(this).next('.tab-content').slideDown();
		}
	});

	$('.tab-container').on('click', '.tab-header', function () {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$(this).next('.tab-content').slideUp();
		} else {
			$('.tab-container .tab-header').removeClass('open');
			$('.tab-container .tab-content').slideUp();

			var $tab = $(this);
			var $content = $tab.next();

			$tab.addClass('open');
			$content.slideToggle();
		}
	});
}

export default tabs;
